module.exports = __webpack_public_path__ + "3b2ab491c31491f1a9f095e78af8c5bc.pdf";